module.exports = __webpack_public_path__ + "img/logo-南华大学.7f7c3a11.png";